module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 35